<template>
  <div class="llz-list-page">
    <van-nav-bar class="topBar" :title="llzName" left-arrow left-text="返回" right-text="主页"
      @click-left="onClickLeft" @click-right="handleHome"
    />
    <van-dropdown-menu :overlay="false">
      <van-dropdown-item v-model="searchForm.llzName" :options="options" @change="handlerChange" />
    </van-dropdown-menu>
    <div class="container">
      <div v-if="llzlist.length > 0" class="card-llz">
        <div v-for="(el, index) in llzlist" :key="index" >
          <van-cell-group>
            <van-cell class="llz-name" :value="el.address" icon="location-o"/>
            <van-cell title="联系人姓名：" :value="el.principal" />
            <van-cell title="联系人电话：" :value="el.phone" />
            <van-cell title="接待时间：" :value="el.date" />
          </van-cell-group>
          <div class="btn-bar">
            <van-button class="btn" color="rgba(93, 185, 232, 1)" @click="handleLlzXq">联络站详情</van-button>
            <van-button class="btn" color="rgba(93, 185, 232, 1)" @click="toLlzLink">提建议</van-button>
          </div>
        </div>
      </div>
      <div v-if="llzlist.length <= 0" class="empty" >
        <van-empty class="custom-image" image="https://img01.yzcdn.cn/vant/custom-empty-image.png" description="该地区暂无代表联络站" style="width: 90%" />
      </div>
    </div>
    <!-- 代表信息页面 -->
    <van-search v-model="searchChildForm.dbName" show-action
      placeholder="请输入代表姓名" @search="onSearch" @cancel="onCancel" />
    <div class="con" v-if="dbList.length !== 0">
      <div class="card" v-for="(el, index) in dbList" :key="index">
        <van-row>
          <van-col span="4">
            <div v-if="el.rolesName.includes('议政员')">
              <img class="dbimg" :src="el.dbHeadicon ? $api + el.dbHeadicon +'&type=1' : $api + '0' + '&type=1'" />
            </div>
            <div v-else>
              <img class="dbimg" :src="el.dbHeadicon ? http2 + el.dbHeadicon +'&type=1' : $api + '0' + '&type=1'"/>
            </div>
          </van-col>
          <van-col span="20">
            <div class="dbname">
              <span>{{ el.dbName }}</span>
              <span class="sex">{{ el.sex }}</span>
              <span class="level">{{ el.rolesName }}</span>
            </div>
            <div class="dbdetail">
              <span v-if="el.company">{{ el.company }}</span>
              <span v-else>暂无代表相关信息</span>
            </div>
          </van-col>
        </van-row>
        <div class="bottom">
          <van-button class="bottom-btn" icon="search" @click="goto(el)">查详情</van-button>
          <van-button class="bottom-btn" icon="edit" @click="toLink(el)">提建议</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/api/getLLZ.js'
export default {
  name: 'llz',
  data () {
    return {
      val: {},
      points: [],
      value: '',
      activeNames: [0],
      llzlist: [],
      llzId: '',
      llzName: '',
      searchForm: {
        llzName: ''
      },
      http: this.$api,
      options: [],
      dbList: [],
      searchChildForm: {
        dbName: ''
      },
      childLlzid: '',
      childLlzName: '',
      http2: null
    }
  },
  created () {
    this.http2 = process.env.VUE_APP_API_BASE_DBIMAGE_URL + 'api/admin/file/download?fileId='
    this.llzId = this.$route.query.areaid
    this.llzName = this.$route.query.areaname
  },
  mounted () {
    this.fetchLLZlist()
  },
  methods: {
    handleLlzWz () {
      this.$router.push({
        path: '/LLZmap',
        query: { id: this.llzlist[0].id }
      })
    },
    handlerChange () {
      this.ChangeLlzlist()
    },
    handleLlzXq () {
      this.$router.push({
        path: '/LLZdetail',
        query: {
          point: this.childLlzid
        }
      })
    },
    // 第一次获取菜单
    fetchLLZlist () {
      const reqData = {
        pageIndex: 1,
        pageSize: 500,
        areaid: this.llzId,
        ...this.searchForm
      }
      request
        .llzPublicList(reqData)
        .then((res) => {
          this.llzlist = res.list
          this.llzlist.forEach(item => {
            this.options.push({ value: item.llzName, text: item.llzName })
          })
          this.searchForm.llzName = this.options[0].value
          this.ChangeLlzlist()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async ChangeLlzlist () {
      const reqData = {
        pageIndex: 1,
        pageSize: 500,
        areaid: this.llzId,
        ...this.searchForm
      }
      const res = await request.llzPublicList(reqData)
      this.llzlist = res.list
      this.dbList = []
      if (this.llzlist.length > 0) {
        this.childLlzid = this.llzlist[0].id
        this.childLlzName = this.llzlist[0].llzName
        this.fetchDBlist()
      }
    },
    goto (val) {
      this.$router.push({
        path: '/Dbinfo',
        query: {
          id: val.id,
          dbName: val.dbName
        }
      })
    },
    // 代表信息页面
    onSearch () {
      this.fetchDBlist()
    },
    onCancel () {
      this.searchChildForm = {}
      this.fetchDBlist()
    },
    fetchDBlist () {
      console.log(1)
      const reqData = {
        pageIndex: 1,
        pageSize: 500,
        llzid: this.childLlzid,
        ...this.searchChildForm
      }
      this.$toast.loading({
        duration: 0, // 持续时间，0表示持续展示不停止
        forbidClick: true, // 是否禁止背景点击
        message: '加载中...' // 提示消息
      })
      // try {
      request
        .llzDBList(reqData)
        .then((res) => {
          this.$toast.success('人员加载成功')
          console.log(res)
          this.dbList = res.list
        })
        .catch((error) => {
          this.$toast.success('人员加载失败')
          console.log(error)
        })
    },
    toLink (val) {
      this.$router.push({
        path: '/suggess',
        query: {
          id: val.id,
          dbName: val.dbName
        }
      })
    },
    toLlzLink () {
      this.$router.push({
        path: '/suggess',
        query: {
          id: this.childLlzid,
          llzName: this.childLlzName
        }
      })
    },

    onClickLeft () {
      this.$router.go(-1)
    },
    handleBack () {
      this.$router.go(-1)
    },
    handleHome () {
      this.$router.push('/home')
    }
  }
}
</script>
<style lang="less" scoped>
.llz-list-page{
  .container {
    padding: 25px;
    background-color: rgba(248, 248, 248, 1);
    .card-llz{
      .llz-name{
        font-size: 32px;
        font-weight: 600;
        color: #333333;
      }
      /deep/ .van-cell__title{
        font-size: 32px;
        font-weight: 600;
        color: #333333;
      }
      .btn-bar{
        display: flex;
        justify-content:space-between;
        margin-top: 25px;
        .btn{
          width: calc(50% - 12.5px);
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .bottom-btn{
      width: 50%;
      font-weight: 600;
      color: rgba(103, 189, 233, 1);
    }
  }
}
.topBar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.top {
  position: fixed;
  top: 12vw;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 9999;
  background: #fff;
}

/deep/.van-dropdown-menu {
  margin-top: 95px;
}
.con {
  padding: 25px;
  background-color: rgba(248, 248, 248, 1);
  .card {
    background: #fff;
    margin-bottom: 25px;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  }
  .card:last-child{
    margin-bottom: 0;
  }
  .dbimg {
    height: 116px;
  }
  .dbname {
    font-size: 34px;
    font-weight: 600;
    border-bottom: 1px solid rgb(218, 218, 218);
    padding-bottom: 8px;
    .sex {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
    .level {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
  }
  .dbdetail {
    font-size: 28px;
    line-height: 40px;
    margin-top: 10px;
    color: #a5a2a2;
    font-family: Source Han Sans CN;
  }
}
</style>
